import * as React from 'react';
import { styled } from '../theme';

export interface BetaPillWidgetProps {
  className?: any;
  active?: boolean;
}
export const BetaPillWidget: React.FC<BetaPillWidgetProps> = (props) => {
  return (
    <S.Container active={!!props.active} className={props.className}>
      BETA
    </S.Container>
  );
};
namespace S {
  export const Container = styled.div<{ active: boolean }>`
    padding: 5px 10px;
    background: ${(p) => (p.active ? p.theme.dialog.background : p.theme.beta.background)};
    color: ${(p) => p.theme.beta.foreground};
    border-radius: 15px;
    font-size: 12px;
    font-weight: bold;
    display: inline-block;
  `;
}
